import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRakebackChips = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		"data-name": "Icon - Rakeback",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M5.261 4.839C2.687 5.104.75 6.241.75 7.604",
				"data-name": "Path 7766"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M.75 7.607c0 1.56 2.529 2.824 5.648 2.824s5.649-1.264 5.649-2.824a2.04 2.04 0 0 0-.964-1.579",
				"data-name": "Path 7767"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M.75 7.606v8.19c0 1.561 2.529 2.825 5.648 2.825s5.649-1.264 5.649-2.825v-8.19",
				"data-name": "Path 7768"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.047 11.703c0 1.559-2.529 2.824-5.648 2.824S.75 13.262.75 11.703",
				"data-name": "Path 7769"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m22.142 17.662-6.492-.029.032-6.5",
				"data-name": "Path 7770"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.816 17.351a29 29 0 0 0 5.021-5.648c2.386-3.507 1.229-7.611-2.4-9.875s-8.929-.82-10.77 4.2",
				"data-name": "Path 7771"
			})
		]
	})
});
export { SvgRakebackChips as ReactComponent };
